export const STATUS_FILTERS = [
  {label: 'Available', value: 'available'},
  {label: 'Purchased', value: 'purchased'},
  {label: 'Out of Stock', value: 'out of stock'},
];

export const LINK_STORE_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
};

export const PRODUCT_SYNC_SUCCESSFUL_MESSAGES = [
  'Success',
  'Included Invalid Products',
  'Empty List',
];

export const getStatusFilterByValue = value =>
  STATUS_FILTERS.find(f => f.value === value);
